import { createSlice } from "@reduxjs/toolkit";
import {
  getModel,
} from "./modelService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  modelList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Model List ---------- */
    builder
      .addCase(getModel.pending, (state) => {
        state.modelList.status = STATUS.LOADING;
        state.modelList.error = null;
      })
      .addCase(getModel.fulfilled, (state, action) => {
        state.modelList.status = STATUS.SUCCEEDED;
        state.modelList.data = action?.payload || [];
      })
      .addCase(getModel.rejected, (state, action) => {
        state.modelList.status = STATUS.FAILED;
        state.modelList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectModelList = (state) =>
  state.model.modelList;

export default modelSlice.reducer;
